import { push } from 'connected-react-router';
import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import * as api from './api';
import * as types from './types';
import * as constants from './constants';


export const updatePathByTab = (payload, url) => {
  const pathElements = url.split('/');
  const lastPathElement = pathElements[pathElements.length - 1];

  if (constants.TAB_NAMES.includes(lastPathElement)) {
    return push(url.replace(lastPathElement, payload));
  }

  const urlWithSlash = url.endsWith('/') ? url : `${url}/`;

  return push(`${urlWithSlash}${payload}`);
};

export const getOrgUsers = createApiAction(
  types.GET_ORG_USERS,
  api.getOrgUsers,
  { meta: { skipErrorPage: true } },
);

export const getTeamList = createApiAction(
  types.TEAMLIST_GET,
  api.getTeams,
  { meta: { skipErrorPage: true } },
);

export const clearRdcOffset = createAction(types.CLEAR_RDC_OFFSET);
export const decreaseRdcOffset = createAction(types.DECREASE_RDC_OFFSET);
export const increaseRdcOffset = createAction(types.INCREASE_RDC_OFFSET);
export const setCloudType = createAction(types.SET_CLOUD_TYPE);
export const filtersInitialized = createAction(types.INITIALIZE_FILTERS);
